<template>
    <router-link :to="`/session/${sessionStore.selectedSession}/user/${userID}`">
        <li class="search-result__list-item" :class="{ searchedItem: !recent, recentSearchedItem: recent }" tabindex="0" :key="userID" @click.stop="itemSelected" @keydown.enter="itemSelected">
            <sAvatar :src="userPhoto" />
            <span class="search-result__list-item__fullname">{{ nameFormat(userFullname) }}</span>
            <i class="pi pi-arrow-up-right search-result__list_item__enter-symbol"></i>
        </li>
    </router-link>
</template>

<script setup>
import { nameFormat } from '../../../utils/nameFormat';
import { useSessionStore } from '@stores';

const emit = defineEmits(['userClicked', 'recentUserClicked']);

const sessionStore = useSessionStore();

const { user, userID, userPhoto, userFullname, recent } = defineProps({
    user: {
        type: Object,
        required: true,
    },
    userID: {
        type: String,
        required: true,
    },

    userPhoto: {
        type: String,
    },

    userFullname: {
        type: String,
        required: true,
    },

    recent: {
        type: Boolean,
        default: false,
    },
});

const itemSelected = () => {
    if (recent) {
        emit('recentUserClicked', userID);
        return;
    }

    emit('userClicked', user);
};
</script>

<style scoped>
.search-result__list-item {
    @apply flex items-center gap-x-3 p-3 cursor-pointer rounded-2xl outline-none hover:bg-[#1C1C1C05] focus:bg-[#1C1C1C05] dark:hover:bg-zinc-800 dark:focus:bg-zinc-800;
}

.search-result__list-item__fullname {
    @apply text-[--main-black] dark:text-[--main-white] grow truncate;
}

.search-result__list_item__enter-symbol {
    @apply text-[#1C1C1C40] dark:text-[--main-white];
}
</style>
